import { useState, useEffect } from 'react';
import Navigation from './Navigation';

export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20modern%20metropolitan%20city%20skyline%20during%20golden%20hour%20sunset%20with%20warm%20orange%20and%20pink%20tones%2C%20professional%20urban%20landscape%20photography%20showing%20downtown%20skyscrapers%20and%20business%20district%2C%20cinematic%20lighting%20with%20soft%20glowing%20atmosphere%2C%20high-end%20real%20estate%20photography%20style%2C%20ultra-wide%20angle%20perspective%20capturing%20the%20vibrant%20cityscape%2C%20professional%20architectural%20photography%20with%20depth%20and%20dimension&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Metropolitan Skyline"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/30 to-black/20"></div>
      </div>

      {/* Navigation */}
      <Navigation />

      {/* Hero Content */}
      <div className="relative h-full flex items-end pb-24 px-8 md:px-16 lg:px-24">
        <div className="max-w-7xl w-full">
          <div className="max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center px-6 py-2 rounded-full border-2 border-white/40 backdrop-blur-sm mb-8">
              <span className="text-white text-sm font-medium whitespace-nowrap">Trusted by 500+ Corporations</span>
            </div>

            {/* Headline */}
            <h1 className="text-white mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              <div className="text-6xl md:text-7xl lg:text-8xl font-light leading-tight mb-2">
                Seamless Corporate
              </div>
              <div className="text-6xl md:text-7xl lg:text-8xl font-light leading-tight">
                Relocations
              </div>
              <div className="text-5xl md:text-6xl lg:text-7xl font-light leading-tight mt-4 text-white/90">
                Across North America
              </div>
            </h1>

            {/* Description */}
            <p className="text-white/90 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed">
              Expert relocation services tailored for enterprises. We handle every detail of your corporate moves with precision, care, and unmatched professionalism.
            </p>

            {/* CTA Button */}
            <button className="group bg-gradient-to-r from-orange-500 to-coral-500 hover:from-orange-600 hover:to-coral-600 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-2xl flex items-center gap-3 whitespace-nowrap">
              Start Your Journey
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
